var appConfig = {
  env: {
    local: {
      // rest_api_host: "http://192.168.0.15:5000",
      rest_api_host: "http://127.0.0.1:5000",
      redirectUri: "http://localhost:3000/",
      instrumentationKey: 'InstrumentationKey=c89cc1aa-819e-4eda-9122-aebabc20ebac;IngestionEndpoint=https://eastus2-3.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus2.livediagnostics.monitor.azure.com/;ApplicationId=0a64f897-2dc9-443c-91b2-c4259f91e38f'
    },
    dev: {
      rest_api_host: "https://ir-risk-dev-eus2.supply-chain.havi.com",
      redirectUri: "https://ir-portal-dev-eus2.supply-chain.havi.com/",
      clientId: "e28442c3-e409-4390-af33-ff8b892f0d5b",
    },
    uat: {
      rest_api_host: "https://ir-risk-stg-eus2.supply-chain.havi.com",
      redirectUri: "https://ir-portal-stg-eus2.supply-chain.havi.com/",
      clientId: "6bfb3346-ccb9-4042-bc44-a7e347764bbf",
    },
    prod: {
      rest_api_host: "https://ir-risk-prd-eus2.supply-chain.havi.com",
      redirectUri: "https://ir-portal-prd-eus2.supply-chain.havi.com/",
      clientId: "2c2c20f8-83d1-4278-9d8a-c597554873ef"
    },
  },

  rest_api_uri: {
    wf_meta_data: "/workflow/fetch_work_flow_meta_data",
    wf_details: "/workflow/fetch_risk_work_flow_details",
    wf_submit: "/workflow/submit_workflow_data",
    wf_run_scenario: "/workflow/run_scenario",
    strategic_risk_data: "/strategic_risks/fetch_strategic_risk_data",
    strategic_trend_data: "/strategic_risks/fetch_risk_trend_data",
    risk_work_flow_header_details:
      "/workflow/fetch_risk_work_flow_header_details",
  },

  help_doc:
    "https://myhavi.sharepoint.com/:w:/s/ProjectIlluminate-InternalSite-IlluminatePhase2/EfwugLbevDdHiV8lQgHazfsBJaqZ7c7NebLCbUOXUNP2KA?e=nNML7d&isSPOFile=1&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiIyOC8yMjA4MTYwMTQwMiIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D&CID=7AB41015-17F8-4EEF-A8FF-886A9FFC6E5A&wdLOR=c67FD3324-4743-4612-A53B-B96ECCB74668",

  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  riskStatus: {
    New: "Risk case is not yet reviewed",
    "In Progress": "Risk analysis and action plan are being reviewed",
    Actioned:
      "Risk mitigation plan established and being reviewed for execution",
    Closed: "Risk case has been mitigated",
    NA: "Risk is not impactful",
  },
  toolTipTags: {
    communication: "Communication",
    riskCaseSummaryAnalysis: "Risk Case Summary Analysis",
  },
  impactEvalStatus: [
    "Crisis Management",
    "Strategic Decision / Escalation",
    "Operational / Routine",
    "Not Applicable",
  ],
  user: "Test User",

  clientId: "b17983aa-3b21-4912-84ea-e15c9f84db25",

  authority:
    "https://login.microsoftonline.com/585bda71-88ce-428b-9832-95eaa3dce989",

  current_env: process.env.REACT_APP_MY_ENV,

  pieChartRiskLevelMap: {
    "High Risk": "high",
    "Medium Risk": "med",
    "Low Risk": "low",
  },
  sortStatus: {
    New: 1,
    "In Progress": 2,
    Actioned: 3,
    Closed: 4,
    NA: 5,
  },
};

module.exports = {
  appConfig,
};
